module.exports = __webpack_public_path__ + "static/Awards-46f6b314473515ff71399d86370e39e5.png";